import Quill from 'quill';
import { isMobile } from '../../../shared/helpers/toolbarConfig';

// const HighlightBlot = Quill.import('blots/inline');

// class HashtagBlot extends HighlightBlot {}
// HashtagBlot.blotName = 'hashtag';
// HashtagBlot.tagName = 'mark';
// HashtagBlot.className = 'hashtag-blue';
// Quill.register(HashtagBlot);

// class CustomHighlightBlot extends HighlightBlot {}
// CustomHighlightBlot.blotName = 'highlight';
// CustomHighlightBlot.tagName = 'mark';
// Quill.register(CustomHighlightBlot);

const Font = Quill.import('formats/font');
Font.whitelist = [
    'arial',
    'times-new-roman',
    'courier',
    'comic-sans',
    'verdana',
    'georgia',
    'impact',
    'tahoma',
    'trebuchet',
    'palatino',
    'lucida-sans',
];
Quill.register(Font, true);

export const fullToolbar = [
    [{ font: Font.whitelist }],
    [{ header: [1, 2, 3, false] }],
    [{ align: [] }],
    ['bold', 'italic', 'underline'],
];

export const mobileToolbar = [
    [{ font: Font.whitelist }],
    [{ header: [1, 2, 3, false] }],
    [{ align: [] }],
    ['bold', 'italic', 'underline'],
];

export const modules = {
    toolbar: {
        container: isMobile() ? mobileToolbar : fullToolbar,
    },
};
